import { ReactNode } from 'react';
import Text from '@/components/common/Text/Text';
import { useGentleBlurField } from '@/components/form/lib/useGentleBlurField';

type SelectProps = {
  name: string;
  label: ReactNode;
  options: string[];
  className?: string;
  /** Optional HTML autocomplete token (e.g. "address-level1"). */
  autoComplete?: string;
};

function Select(props: SelectProps) {
  const { name, label, className, options, autoComplete } = props;
  const [field, meta /*, helpers */] = useGentleBlurField({ name });

  return (
    <div className={'Select'}>
      <label className='Select-label'>{label}</label>
      <select
        className={className + `${meta.touched && meta.error ? ' Error' : ''}`}
        autoComplete={autoComplete}
        {...field}
      >
        {options.map((i) => (
          <option
            key={i}
            value={i}
            disabled={i === ''}
          >
            {i}
          </option>
        ))}
      </select>
      {meta.touched && meta.error && (
        <div className='Select-error'>
          <Text className='Select-error-text'>{meta.error}</Text>
        </div>
      )}
    </div>
  );
}

export default Select;
